import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router';
import { format } from 'date-fns';
import TableLightBackground from '../../Components/TableLightBackground/TableLightBackground';
import { useGetNotesQuery } from '../../redux/rtkQuery/notesApiSlice';

const NotePageTable = () => {
  // @ts-ignore
  const { permitId } = useParams();
  const params = {
    is_deleted: false,
    limit: 100,
    offset: 0,
    ordering: '-created_at',
  };
  const { data } = useGetNotesQuery({ params, permit: permitId });
  const [rows, setRows] = useState<any[]>([]);

  useEffect(() => {
    if (data) {
      const _rows = data.results.map(item => {
        return {
          note: item.text,
          addedBy:
            [item.creatorFirstName, item.creatorLastName].filter(Boolean).join(' ') ||
            'Elite Permits',
          created: format(new Date(item.createdAt.substring(0, 20)), 'MM/dd/yyyy hh:mm:ss a'),
        };
      });
      setRows(_rows);
    }
  }, [data]);
  const headers = [
    { title: 'Note', key: 'note', allowLinks: true },
    { title: 'Added By', key: 'addedBy' },
    { title: 'Created', key: 'created' },
  ];
  return <TableLightBackground headers={headers} rows={rows} rowsTemplate="repeat(3, 1fr)" />;
};

export default NotePageTable;
